var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":_vm.getTestId('admin-project-page')}},[_c('ProjectCrudTable',{attrs:{"data-testid":_vm.getTestId('admin-project-table')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }